import mapResponsesToUser from './mappers/mapResponseToUser'
import { ITemplate } from '../Templates'

export default function(api: GlobalFetch) {
  return async function() {
    const response = await api.fetch(`/api/v2/batch/user`)

    try {
      const res = await response.json()
      return {
        ...res.items,
        user: {
          ...mapResponsesToUser(res.items.user),
          serverTime: new Date(response.headers.get('date')),
        },
        templates: res.items.templates.map(
          (item): ITemplate => ({
            content: item.content
              .split('<b>')
              .join('')
              .split('</b>')
              .join('')
              .split('\r\n')
              .join(''),
            createdAt: new Date(Number(item.created_at) * 1000),
            id: Number(item.id),
            idStatus: Number(item.id_status),
            idType: Number(item.id_type),
            idUser: Number(item.id_user),
            language: String(item.language),
            position: String(item.position),
            title: String(item.title),
            typeTitle: String(item.type_title),
            updatedAt: new Date(Number(item.updated_at) * 1000),
          }),
        ),
      }
    } catch (e) {
      throw new Error(e)
    }
  }
}
